export const getToken = () => {
  let token = null;
  if (typeof window !== "undefined") {
    token = localStorage.getItem("token");
  }
  return token;
};

export const getRecaptchaToken = (action) => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    grecaptcha.enterprise.ready(() => {
      // eslint-disable-next-line no-undef
      grecaptcha.enterprise
        // eslint-disable-next-line no-undef
        .execute(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY, {
          action: action,
        })
        .then((token) => {
          resolve(token);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
};
